import { z } from "zod";

export const ManualOrganizationCreateInputSchema = z.object({
  name: z.string().min(1, "Organization name cannot be empty"),
  slug: z
    .string()
    .min(1, "Slug cannot be empty")
    .regex(
      /^[a-z0-9_-]+$/,
      "Slug must contain only lowercase letters, numbers, underscores, and hyphens",
    ),
  gitlabToken: z.string().min(1, "GitLab token cannot be empty"),
});

export type ManualOrganizationCreateInputSchemaType = z.infer<
  typeof ManualOrganizationCreateInputSchema
>;
